import React, { FC, useEffect, useState } from 'react';
import { QuickTipsList, formatCountdown } from "./helper";
import { Link } from "react-router-dom";
import {Alert} from "react-bootstrap";

interface Props {
    data: QuickTipsList[];
    atagParams: string | null,
    viewType?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null
}
interface Countdown {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}
type CountdownOrExpired = Countdown | "Expired";
const QuickbetLobbyComponent: FC<Props> = ({ data, atagParams, viewType,ticketOpenMode, sourceParams }) => {
    const [countdowns, setCountdowns] = useState<{ [key: string]: CountdownOrExpired }>({});
    useEffect(() => {
        const intervals: NodeJS.Timeout[] = [];
        const updatedCountdowns: { [key: string]: CountdownOrExpired } = {};
        data.forEach((item, index) => {
            const countdown = formatCountdown(item.operator_time_expires);
            updatedCountdowns[item.code] = countdown;
            if (typeof countdown !== "string") {
                const intervalId = setInterval(() => {
                    const updatedCountdowns = { ...countdowns };
                    updatedCountdowns[item.code] = formatCountdown(item.operator_time_expires);
                    setCountdowns(updatedCountdowns);
                }, 1000);
                intervals.push(intervalId);
            }
        });

        setCountdowns(updatedCountdowns);
        return () => {
            intervals.forEach((intervalId) => clearInterval(intervalId));
        };
    }, [data]);
    return (
        <div className="col-12">
            {
                data.length > 0 ?
                    <div className="card quicktip-lobby-card mt-3">
                        <div className="card-header">
                            QuickBets
                        </div>
                        <ul className="list-group list-group-flush">
                            {data.map((item, index) => {
                                const countdown = formatCountdown(item.operator_time_expires)
                                return (
                                    <li className={`list-group-item ${index % 2 === 1 ? 'list-item-bg-dark' : 'list-item-bg-light'}`}
                                        key={index}>
                                        <Link
                                            to={(() => {
                                                let url = `quickbet/${item.code}`;
                                                const params = new URLSearchParams();

                                                if (atagParams) params.append('atag', atagParams);
                                                if (viewType) params.append('viewType', viewType);
                                                if (sourceParams) params.append('source', sourceParams);

                                                const queryString = params.toString();
                                                if (queryString) url += `?${queryString}`;

                                                return url;
                                            })()}
                                            className='d-flex justify-content-between align-items-center text-decoration-none text-green js-ticket-link'
                                            target={ticketOpenMode === 'redirect' ? '_blank' : undefined}
                                        >

                                        <span>
                                             <b>{item.events.length} events</b> <br/>
                                        </span>
                                            <span className='quicktip-title'>
                                                {item.title}
                                            </span>
                                            <span className='expires d-flex align-content-center'>
                                        <i className="far fa-clock m-2"/>
                                        <span className='d-flex flex-column align-content-center expires-time'>
                                            <div>
                                                    {
                                                        countdown !== 'Expired' ? (
                                                            <span>
                                                               {
                                                                   countdown.days > 0 ?
                                                                       countdown.days + ' Days'
                                                                       : 'Today in'
                                                               }
                                                            </span>
                                                        ) : null
                                                    }
                                                </div>
                                                <div>
                                                    {
                                                        countdown !== 'Expired' ? (
                                                            <span>
                                                               {
                                                                   `${countdown.hours}:${countdown.minutes}:${countdown.seconds}'`
                                                               }
                                                            </span>
                                                        ) : null
                                                    }
                                                </div>
                                        </span>
                                    </span>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>

                    </div>
                    : <Alert>Loading...</Alert>
            }
        </div>
    );
}

export default QuickbetLobbyComponent;
